import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import AntiCorruption from '../components/Achievements/AntiCorruption';
import Infrastructure from '../components/Achievements/Infrastructure';
import Introduction from '../components/Achievements/Introduction';
import Privacy from '../components/Achievements/Privacy';
import Download from '../components/Home/Download';
import AchievementsBanner from '../components/Achievements/AchievementsBanner';
import { isMobileContext } from '../components/context/isMobileContext';
export default function People() {
    const {t} = useTranslation();
    const {isMobile}=useContext(isMobileContext)
    const bannerData = {
        our: t("people_page.banner.our"),
        headline1: t("people_page.banner.headLine1"),
        headline2: t("people_page.banner.headLine2-1"),
        description: t("people_page.banner.description"),
        worldClass: t("people_page.banner.world_class"),
        img: '/imgs/achievements/people/people-banner.png'
      }

      const workplaceData = {
        subtitle :  t("people_page.workplace.subtitle"),
        title1: t("people_page.workplace.title1"),
        title2: t("people_page.workplace.title2"),
        desc: t("people_page.workplace.description"),
        cardsData: [
          {
            title: t("people_page.workplace.cardsDataTitle1"),
            img: t("people_page.workplace.img1")
          },
          {
            title: t("people_page.workplace.cardsDataTitle2"),
            img: t("people_page.workplace.img2")
          },
          {
            title: t("people_page.workplace.cardsDataTitle3"),
            img: t("people_page.workplace.img3")
          },
          {
            title: t("people_page.workplace.cardsDataTitle4"),
            img: t("people_page.workplace.img4")
          },
        ]
      }

      const trainingData = {
        subtitle :  t("people_page.training.subtitle"),
        title1: t("people_page.training.title1"),
        title2: t("people_page.training.title2"),
        desc: t("people_page.training.description"),
        cardsData: [
          {
            title: t("people_page.training.cardsDataTitle1"),
            img: t("people_page.training.img1")
          },
          {
            title: t("people_page.training.cardsDataTitle2"),
            img: t("people_page.training.img2")
          },
          {
            title: t("people_page.training.cardsDataTitle3"),
            img: t("people_page.training.img3")
          },
          {
            title: t("people_page.training.cardsDataTitle4"),
            img: t("people_page.training.img4")
          },
        ]
      }
      const diversityData = {
        subtitle :  t("people_page.diversity.subtitle"),
        title1: t("people_page.diversity.title1"),
        title2: t("people_page.diversity.title2"),
        desc: t("people_page.diversity.description"),
        cardsData: [
          {
            title: t("people_page.diversity.cardsDataTitle1"),
            img: t("people_page.diversity.img1"),
          },
          {
            title: t("people_page.diversity.cardsDataTitle2"),
            img: t("people_page.diversity.img2"),
          },
          {
            title: t("people_page.diversity.cardsDataTitle3"),
            img: t("people_page.diversity.img3"),
          },
          {
            title: t("people_page.diversity.cardsDataTitle4"),
            img: t("people_page.diversity.img4"),
          },
          {
            title: t("people_page.diversity.cardsDataTitle5"),
            img: t("people_page.diversity.img5"),
          },
          {
            title: t("people_page.diversity.cardsDataTitle6"),
            img: t("people_page.diversity.img6"),
          },
          {
            title: t("people_page.diversity.cardsDataTitle7"),
            img: t("people_page.diversity.img7"),
          },
        ]
      }
      const labourData = {
        line1: t("people_page.labour.line1"),
        line2: t("people_page.labour.line2"),
        descriptions: [
          t("people_page.labour.description1")
      ],
        img: '/imgs/achievements/people/labour.png'
      }
      const employmentData = {
        line1: t("people_page.employment.line1"),
        line2: t("people_page.employment.line2"),
        line3: t("people_page.employment.line3"),
        descriptions : [
          t("people_page.employment.description1")
          ],
        img: '/imgs/achievements/people/employment.png'
      }
      const rightsData = {
        line1: t("people_page.rights.line1"),
        line2: t("people_page.rights.line2"),
        description :
          t("people_page.rights.description")
      }

      const volunteeringData = {
        line1: t("people_page.volunteering.line1"),
        descriptions : [
          t("people_page.volunteering.description1"),
        ],
        img: '/imgs/achievements/people/volunteering.png'
      }

  return (
    <div>
        <Helmet>
            <title>{t('head.people')}</title>
        </Helmet>
        <AchievementsBanner bannerData={bannerData} uniqueClass={"people"}/>
        {/* <Introduction uniqueClass={"people"}/> */}
        <Infrastructure data={workplaceData} section={"workplaceSection"} normalSwiperLayers uniqueClass={"people"} />
        <Infrastructure data={trainingData} section={"trainingSection"} environmentMobileLayer={isMobile?true:false} invertedSwiper={isMobile?false:true} uniqueClass={"people"}/>
        <Infrastructure data={diversityData} section={"diversitySection"} diversitySwiper normalSwiperLayers={isMobile?true:false} uniqueClass={"people"}/>
        <Privacy data={employmentData} normalSwiperLayers={isMobile?true:false} invertedSection employmentSection privacyLayer1={isMobile?false:true} uniqueClass={"people"}/>
        <AntiCorruption data={rightsData}  uniqueClass={"people"}/>
        <Privacy data={labourData} invertedSection  environmentMobileLayer={isMobile?true:false} marker privacyLayer1={isMobile?false:true} labourSection uniqueClass={"people"}/>
        <Privacy data={volunteeringData} removeImg={isMobile?true:false} environmentMobileLayer={isMobile?true:false} volunteeringSection   uniqueClass={"people"}/>
        {/* <Download/> */}
    </div>
  )
}
